import { toKoreanDate } from './withdrawalAmendmentDates';

/**
 * 약속 기록 수집·공개 개정(이용약관 제6조의2·제9조 제3항, 개인정보 수집·이용 동의 1·2·3항, 제3자 제공 3항) 날짜.
 * **시행일은 [PROMISE_RECORD_EFFECTIVE_ISO] 한 값만 고친다** — 게시일·약관 버전(TERMS_VERSION)이 따라간다.
 * 기본값은 2026-11-02(사용자 지시 "약관도 바로 수정해서 추가해", 2026-11-02). 제3조 제2항은 회원에게 불리한 변경이면 30일 전 공지를 요구하므로
 * 공지 30일을 두려면 이 값을 게시일 + 30일로 바꾼다. 공개 스위치(어드민 기능 공개 '약속 기록 공개')는 시행일이 지난 뒤 켠다.
 */
export const PROMISE_RECORD_EFFECTIVE_ISO = '2026-11-02';
/** 게시일 — 시행일과 같은 날(시행일을 늦추면 이 값을 실제 게시일로 따로 적는다) */
export const PROMISE_RECORD_NOTICE_ISO: string = PROMISE_RECORD_EFFECTIVE_ISO;

export const PROMISE_RECORD_EFFECTIVE_DATE: string = toKoreanDate(PROMISE_RECORD_EFFECTIVE_ISO);
export const PROMISE_RECORD_NOTICE_DATE: string = toKoreanDate(PROMISE_RECORD_NOTICE_ISO);
